import {axiosInstance} from "@/services/axios.instance";

export const deliveryPoints = async (params) => await axiosInstance.get('/map/deliveryPoints ', {params});
export const deliveryPickupPoints = async (params) => await axiosInstance.get('/map/deliveryPickupPoints', {params});

const controller = new AbortController();

export const fetchProviders = async (baseurl) => await axiosInstance({ url: '/map/providers', baseURL: baseurl })

export const fetchPickupPoints = async (baseurl, params) => {
 return await axiosInstance({ url: '/map/deliveryPickupPoints', baseURL: baseurl, params: params,  signal: controller.signal })
}